export default __webpack_public_path__ + "static/media/man_with_phone_white.10c15fd8.png";